import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { GridCellType } from "../../common/enums/GridCellType";
import { SystemBalanceTypeEnum } from "../../common/enums/SystemBalanceTypeEnum";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { AccessPermission, IAccessPermission } from "../../common/models/AccessPermission";
import { IBaseGridModel } from "../../common/models/IBaseGridModel";
import * as DRCX from "../../common/enums/DRCXEnums";
import { ISummaryListingDataModel, ISummaryListingSortParams } from "./BaseModels";

export interface IWellSummaryGridRestQueryParams {
    configurationID: number;
    correlationID: string;
}

export interface IWellSummaryModel extends ISummaryListingDataModel {
    gridData?: IWellSummaryGridModel;
}

export class WellSummaryModel implements IWellSummaryModel {
    public configurationID?: number;
    public userPermissions?: Array<AccessPermission>;
    public gridData?: IWellSummaryGridModel;

    constructor(model?: IWellSummaryModel) {
        if (model) {
            this.configurationID = model.configurationID;
            this.userPermissions = model.userPermissions?.map(
                (permission: IAccessPermission): AccessPermission => new AccessPermission(permission)
            );
            this.gridData = model.gridData;
        }
    }
}

export interface IWellSummaryGridModel extends IBaseGridModel<IWellSummaryGridRow> { }

export interface IWellSummaryGridRow {
    wellID: number;
    wellName: string;
    systemBalanceType: SystemBalanceTypeEnum;
    hasTagThreads: boolean;
    hasCommError: boolean;
    hasRecentMemo: boolean;
    hasArchives: boolean;
    hasWellTrending: boolean;
    hasLiveData: boolean;
    hasMarketingReport: boolean;
    hasPlungerLiftRunStatistics: boolean;
    hasTankGaugeSheet: boolean;
    hasDynacardView: boolean;
    hasIssuesAndActions: boolean;
    memoText: string;
    memoTimestamp: string;
    memoID: number | undefined;
    alarmStatus: number;
    cells: IWellSummaryGridCell[];
    order?: number
    active: boolean;
}

export interface IWellSummaryGridCell {
    displayText: string;
    objectType: eLynxObjectTypeEnum;
    objectID?: number;
    dataValue?: number;
    displayTimeframe?: TimeframeTypeEnum;
    timestamp?: string;
    inAlarm: boolean;
    backgroundColor: string;
    inStaleDataAlarm: boolean;
    staleDataColor: string;
    optionalColumn?: DRCX.OptionalColumnEnum;
    // This should go away later and GridCellType should be used in the UI and WebAPI. The UI must be changed first.
    isAttributeCell: boolean;
    gridCellType?: GridCellType;
}

export interface IWellSummarySortParams extends ISummaryListingSortParams {
    sortBySystemBalanceType: boolean;
    sortByWellsInAlarmFirst: boolean;
    //sortByRecentMemo: boolean;
    //sortAscending: boolean;
    //sortColumnIndex: number;
}

// #endregion Polled Devices Models
